const Divider = () => {
	return (
		<div
			style={{
				borderRight: '1.5px solid gray',
				height: '80px',
			}}
		/>
	);
};

export default Divider;
